'use strict';

import React from 'react';
import { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';

import Loader from '../helper/Loader';

function Dashboard() {
    const { request } = useRequest();

    const [data, setData] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let result = await request("/Operator/GetDashboard");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten.");
                    }
                }
                else {
                    setData(json.data);
                }
            }
            catch (ex) {
                console.error(ex);
                toast.error("Es ist ein Fehler aufgetreten.");
            }
        };
        fetchData();
    }, []);

    if (data === false) return <Loader />

    return (
        <Table striped>
            <thead>
                <tr>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <tr key={index}>
                        <td>{item.Caption}</td>
                        <td>{item.Value}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}

export default Dashboard;